import { gql } from "@apollo/client";
import { useLazyQuery, useMutation } from "@apollo/client/react";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from '../../../components/hooks/useForm';

import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SearchIcon from '@mui/icons-material/Search';
import { Checkbox, FormControl, FormControlLabel, FormGroup, InputAdornment, InputLabel, MenuItem, Select, Stack, Switch, TextField, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { styled } from '@mui/material/styles';
import toast from 'react-hot-toast';
import ErrorDialog from '../../../components/ErrorDialog';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';

export default function ConfigPreset({ data }) {

  const IdTipoModulo = useRef(0);
  const [openDlgCliente, setOpenDlgCliente] = useState(false);

  // dlg de error
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  const [selectedRows, setSelectedRows] = React.useState([]);

  const [dataTipoModulo, setDataTipoModulo] = useState(null);
  const [valorFranjaEtaria, setValorFranjaEtaria] = useState('');
  const txtBuscarCliente = useRef(null);
  const [clientes, setClientes] = useState('');
  const [dataOriginalClientes, setDataOriginalClientes] = useState('');

  const [checkedActivoGeneral, setCheckedActivoGeneral] = useState(false);
  const [checkedActivoFE, setCheckedActivoFE] = useState(false);
  const [checkedActivoTM, setCheckedActivoTM] = useState(false);
  const [checkedActivoC, setCheckedActivoC] = useState(false);


  const [formValues, formHandle, reset, setFormValues] = useForm({
    IdTipoModulo: 0
  });

  const [statePresetTipoModulo, setStatePresetTipoModulo] = useState({
    showDataGrid: false,
    data: ''
  });

  const [statePresetCliente, setStatePresetCliente] = useState({
    showDataGrid: false,
    data: ''
  });

  const [stateClientes, setStateClientes] = useState([]);

  useEffect(() => {
    const presetUsuario = sessionStorage.getItem("presetUsuarioActivo");
    if (presetUsuario) {
      setCheckedActivoGeneral(presetUsuario === 'true');
    }

    let result = getPresetTipoModulo();
    let resultP = getPresetPaciente();
    let resultCl = getPresetCliente();
    let resultComboTipoModulo = getComboTipoModulo();

  }, []);

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const QTipoModulos = gql`
        query QTipoModulos{
            tipoModulos {
                success,
                error,
                valorEsperado {
                  idTipoModulo,
                  descripcion,
                  abreviacion
                }
              }
    }`;
  const [getComboTipoModulo, { data: dataQTipoModulos, error: errorTipoModulos }] = useLazyQuery(QTipoModulos, {
    fetchPolicy: 'cache-and-network'
  });

  useEffect(() => {
    if (!dataQTipoModulos) return;
    if (dataQTipoModulos.tipoModulos.success) {
      setDataTipoModulo(dataQTipoModulos.tipoModulos.valorEsperado);
    }
  }, [dataQTipoModulos]);

  useEffect(() => {
    if (!errorTipoModulos) return;
    setMensajeError("ERRORDB");
  }, [errorTipoModulos]);

  const QPresetPaciente = gql`
        query QPresetPaciente{
            presetUsuarioPaciente {
                success,
                error,
                valorEsperado {
                    id,
                    idUsuario,
                    idFranjaEtaria,
                    activo
                }
              }
    }`;
  const [getPresetPaciente, { data: dataQPresetPaciente, error: errorPresetPaciente }] = useLazyQuery(QPresetPaciente, {
    fetchPolicy: 'cache-and-network'
  });

  useEffect(() => {
    if (!dataQPresetPaciente) return;
    if (dataQPresetPaciente.presetUsuarioPaciente.success) {
      setValorFranjaEtaria(dataQPresetPaciente.presetUsuarioPaciente.valorEsperado.idFranjaEtaria);
      setCheckedActivoFE(dataQPresetPaciente.presetUsuarioPaciente.valorEsperado.activo);
    }
  }, [dataQPresetPaciente]);

  useEffect(() => {
    if (!errorPresetPaciente) return;
    setMensajeError("ERRORDB");
  }, [errorPresetPaciente]);

  const QPresetTipoModulo = gql`
        query QPresetTipoModulo{
            presetUsuarioTipoModulo {
                success,
                error,
                valorEsperado {
                    id,
                    idUsuario,
                    idTipoModulo,
                    activo,
                    descripcion,
                    abreviacion
                }
              }
    }`;
  const [getPresetTipoModulo, { data: dataQPresetTipoModulo, error: errorPresetTipoModulo }] = useLazyQuery(QPresetTipoModulo, {
    fetchPolicy: 'cache-and-network'
  });

  useEffect(() => {
    if (!dataQPresetTipoModulo) return;
    if (dataQPresetTipoModulo.presetUsuarioTipoModulo.success) {
      if (dataQPresetTipoModulo.presetUsuarioTipoModulo.valorEsperado.length > 0) {
        setStatePresetTipoModulo((prevState) => {
          return {
            ...prevState,
            showDataGrid: true,
            data: dataQPresetTipoModulo.presetUsuarioTipoModulo.valorEsperado
          };
        });

        setCheckedActivoTM(dataQPresetTipoModulo.presetUsuarioTipoModulo.valorEsperado[0].activo);
      } else {
        setStatePresetTipoModulo((prevState) => {
          return {
            ...prevState,
            showDataGrid: false
          };
        });
      }
    } else {
      setStatePresetTipoModulo((prevState) => {
        return {
          ...prevState,
          showDataGrid: false
        };
      });
    }
  }, [dataQPresetTipoModulo]);

  useEffect(() => {
    if (!errorPresetTipoModulo) return;
    setMensajeError("ERRORDB");
  }, [errorPresetTipoModulo]);

  const QPresetCliente = gql`
        query QPresetCliente{
            presetUsuarioCliente {
                success,
                error,
                valorEsperado {
                    id,
                    idUsuario,
                    idTipoPreset,
                    idCliente,
                    activo,
                    delegacion,
                    cod_Cliente,
                    cUIT,
                    nom_Com
                }
              }
    }`;
  const [getPresetCliente, { data: dataQPresetCliente, error: errorPresetCliente }] = useLazyQuery(QPresetCliente, {
    fetchPolicy: 'cache-and-network'
  });

  useEffect(() => {
    if (!dataQPresetCliente) return;
    if (dataQPresetCliente.presetUsuarioCliente.success) {
      if (dataQPresetCliente.presetUsuarioCliente.valorEsperado.length > 0) {
        setStatePresetCliente((prevState) => {
          return {
            ...prevState,
            showDataGrid: true,
            data: dataQPresetCliente.presetUsuarioCliente.valorEsperado
          };
        });

        setCheckedActivoC(dataQPresetCliente.presetUsuarioCliente.valorEsperado[0].activo);
      } else {
        setStatePresetCliente((prevState) => {
          return {
            ...prevState,
            showDataGrid: false
          };
        });
      }
    } else {
      setStatePresetCliente((prevState) => {
        return {
          ...prevState,
          showDataGrid: false
        };
      });
    }
  }, [dataQPresetCliente]);

  useEffect(() => {
    if (!errorPresetCliente) return;
    setMensajeError("ERRORDB");
  }, [errorPresetCliente]);

  const QClientes = gql`
        query QClientes{
            mergeCliente {
                success,
                error,
                valorEsperado {
                    cod_Cliente,
                    pais,
                    cod_Condicion,
                    nom_Com,
                    localidad,
                    cUIT,
                    delegacion
                }
              }
    }`;
  const [getClientes, { data: dataQClientes }] = useLazyQuery(QClientes, {
    fetchPolicy: 'cache-and-network'
  });

  useEffect(() => {
    if (!dataQClientes) return;
    if (dataQClientes.mergeCliente.success) {
      setStateClientes(dataQClientes.mergeCliente.valorEsperado);
      setDataOriginalClientes(dataQClientes.mergeCliente.valorEsperado);
    }
  }, [dataQClientes]);

  useEffect(() => {
    if (!dataQClientes?.mergeCliente?.error) return;
    setMensajeError("ERRORDB");
  }, [dataQClientes]);

  const MActivarPresetGeneral = gql`
    mutation MActivarPresetGeneral( $activo: Boolean!){
        activarPreset(activo: $activo) 
        {
            success,
            error,
            valorEsperado
        }
    }`;
  const [activarPresetGeneral, { dataMActivarPresetGeneral }] = useMutation(MActivarPresetGeneral, {
    onCompleted: (dataMActivarPresetGeneral) => {
      if (dataMActivarPresetGeneral.activarPreset.success) {
        setCheckedActivoGeneral(!checkedActivoGeneral);
        sessionStorage.setItem('presetUsuarioActivo', !checkedActivoGeneral);
      } else {
        if (dataMActivarPresetGeneral.activarPreset.error === 'ERRORDB' || parseInt(dataMActivarPresetGeneral.activarPreset.error, 10) > 0) {
          setMensajeError(dataMActivarPresetGeneral.activarPreset.error);
        }
      }
    },
    onError: (dataMActivarPresetGeneral) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const MActivarPresetUsuario = gql`
    mutation MActivarPresetUsuario( $idTipoPreset: Int!, $activo: Boolean!){
        updatePresetUsuario(idTipoPreset: $idTipoPreset, activo: $activo) 
        {
            success,
            error,
            valorEsperado
        }
    }`;
  const [activarPresetUsuario, { dataMActivarPresetUsuario }] = useMutation(MActivarPresetUsuario, {
    onCompleted: (dataMActivarPresetUsuario) => {
      if (dataMActivarPresetUsuario.updatePresetUsuario.success) {
        let idTipoPreset = parseInt(dataMActivarPresetUsuario.updatePresetUsuario.valorEsperado);
        switch (idTipoPreset) {
          case 1:
            setCheckedActivoFE(!checkedActivoFE);
            break;
          case 2:
            setCheckedActivoTM(!checkedActivoTM);
            break;
          case 3:
            setCheckedActivoC(!checkedActivoC);
            break;
        }
      } else {
        if (dataMActivarPresetUsuario.updatePresetUsuario.error === 'ERRORDB' || parseInt(dataMActivarPresetUsuario.updatePresetUsuario.error, 10) > 0) {
          setMensajeError(dataMActivarPresetUsuario.updatePresetUsuario.error);
        }
      }
    },
    onError: (dataMActivarPresetUsuario) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const MTipoModulo = gql`
    mutation MTipoModulo( $idTipoModulo: Int!){
        savePresetUsuarioTipoModulo(idTipoModulo: $idTipoModulo) 
        {
            success,
            error,
            valorEsperado
        }
    }`;
  const [addTipoModulo, { loading, error, dataMTipoModulo }] = useMutation(MTipoModulo, {
    onCompleted: (dataMTipoModulo) => {
      if (dataMTipoModulo.savePresetUsuarioTipoModulo.success) {
        setCheckedActivoTM(true);
        getPresetTipoModulo();
      } else {
        if (dataMTipoModulo.savePresetUsuarioTipoModulo.error === 'ERRORDB' || parseInt(dataMTipoModulo.savePresetUsuarioTipoModulo.error, 10) > 0) {
          setMensajeError(dataMTipoModulo.savePresetUsuarioTipoModulo.error);
        }
      }
    },
    onError: (dataMTipoModulo) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const MCliente = gql`
    mutation MCliente( $idsCliente: [String!]!){
        savePresetUsuarioCliente(idsCliente: $idsCliente) 
        {
            success,
            error,
            valorEsperado
        }
    }`;
  const [addCliente, { dataMCliente }] = useMutation(MCliente, {
    onCompleted: (dataMCliente) => {
      if (dataMCliente.savePresetUsuarioCliente.success) {
        setCheckedActivoC(true);
        getPresetCliente();
        setOpenDlgCliente(false);
        setSelectedRows([]);
      } else {
        if (dataMCliente.savePresetUsuarioCliente.error === 'ERRORDB' || parseInt(dataMCliente.savePresetUsuarioCliente.error, 10) > 0) {
          setMensajeError(dataMCliente.savePresetUsuarioCliente.error);
        }
      }
    },
    onError: (dataMCliente) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const MPaciente = gql`
    mutation MPaciente( $idFranjaEtaria: Int!){
        savePresetUsuarioPaciente(idFranjaEtaria: $idFranjaEtaria) 
        {
            success,
            error,
            valorEsperado
        }
    }`;
  const [addPaciente, { dataMPaciente }] = useMutation(MPaciente, {
    onCompleted: (dataMPaciente) => {
      if (dataMPaciente.savePresetUsuarioPaciente.success) {
        toast.success("Se actualizo la franja etaria");
        setCheckedActivoFE(true);
      } else {
        if (dataMPaciente.savePresetUsuarioPaciente.error === 'ERRORDB' || parseInt(dataMPaciente.savePresetUsuarioPaciente.error, 10) > 0) {
          setMensajeError(dataMPaciente.savePresetUsuarioPaciente.error);
        }
      }
    },
    onError: (dataMPaciente) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const MDeleteTipoModulo = gql`
    mutation MDeleteTipoModulo( $id: Int!){
        deletePresetUsuarioTipoModulo(id: $id) 
        {
            success,
            error,
            valorEsperado
        }
    }`;
  const [deleteTipoModulo, { dataMDeleteTipoModulo }] = useMutation(MDeleteTipoModulo, {
    onCompleted: (dataMDeleteTipoModulo) => {
      if (dataMDeleteTipoModulo.deletePresetUsuarioTipoModulo.success) {
        getPresetTipoModulo();
        if (statePresetTipoModulo.data.length == 1) {
          // último tipo de modulo de la grilla, paso a inactivo el preset
          activarPresetUsuario({ fetchPolicy: 'no-cache', variables: { idTipoPreset: 2, activo: false } });
        }

      } else {
        if (dataMDeleteTipoModulo.deletePresetUsuarioTipoModulo.error === 'ERRORDB' || parseInt(dataMDeleteTipoModulo.deletePresetUsuarioTipoModulo.error, 10) > 0) {
          setMensajeError(dataMDeleteTipoModulo.deletePresetUsuarioTipoModulo.error);
        }
      }
    },
    onError: (dataMDeleteTipoModulo) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const MDeleteCliente = gql`
    mutation MDeleteCliente( $id: Int!){
        deletePresetUsuarioCliente(id: $id) 
        {
            success,
            error,
            valorEsperado
        }
    }`;
  const [deleteCliente, { dataMDeleteCliente }] = useMutation(MDeleteCliente, {
    onCompleted: (dataMDeleteCliente) => {
      if (dataMDeleteCliente.deletePresetUsuarioCliente.success) {
        getPresetCliente();
        if (statePresetCliente.data.length == 1) {
          // último tipo de modulo de la grilla, paso a inactivo el preset
          activarPresetUsuario({ fetchPolicy: 'no-cache', variables: { idTipoPreset: 3, activo: false } });
        }

      } else {
        if (dataMDeleteCliente.deletePresetUsuarioCliente.error === 'ERRORDB' || parseInt(dataMDeleteCliente.deletePresetUsuarioCliente.error, 10) > 0) {
          setMensajeError(dataMDeleteCliente.deletePresetUsuarioCliente.error);
        }
      }
    },
    onError: (dataMDeleteCliente) => {
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const handleAddTipoModulo = () => {
    if (isFormValid()) {
      AgregarTipoModulo();
    }
  };

  const handleAddCliente = () => {
    setOpenDlgCliente(true);
    let result = getClientes({ fetchPolicy: 'no-cache' });
  };

  const handleCloseDlgCliente = () => {
    setSelectedRows([]);
    setOpenDlgCliente(false);
  };

  const handleAddDlgCliente = () => {
    if (isValidCliente())
      addCliente({ fetchPolicy: 'no-cache', variables: { idsCliente: selectedRows } });
  };

  const isValidCliente = () => {

    if (selectedRows.length <= 0) {
      toast.error('Debe seleccionar al menos un cliente');
      return false;
    }

    return true;
  };

  const isFormValid = () => {

    if (formValues.IdTipoModulo <= 0) {
      toast.error('Debe seleccionar un Tipo de Modulo');
      return false;
    }

    if (statePresetTipoModulo.data.length > 0) {
      let result = statePresetTipoModulo.data.find((f) => f.idTipoModulo == formValues.IdTipoModulo);
      if (result) {
        toast.error("El Tipo de Modulo ya fue agregado");
        return false;
      }
    }


    return true;
  };

  const handleFranjaEtaria = (event) => {
    setValorFranjaEtaria(event.target.value);
    let idFranjaEtaria = parseInt(event.target.value);
    AgregarFranjaEtaria(idFranjaEtaria);
  };

  const handleDeleteTipoModulo = (row) => {
    let id = row.id;
    EliminarTipoModulo(id);
  };

  const handleDeleteCliente = (row) => {
    let id = row.id;
    EliminarCliente(id);
  };

  const AgregarFranjaEtaria = (idFranjaEtaria) => {
    let result = addPaciente({ fetchPolicy: 'no-cache', variables: { idFranjaEtaria: idFranjaEtaria } });
  };

  const AgregarTipoModulo = () => {
    let result = addTipoModulo({ fetchPolicy: 'no-cache', variables: { idTipoModulo: formValues.IdTipoModulo } });
  };

  const EliminarTipoModulo = (id) => {
    let result = deleteTipoModulo({ fetchPolicy: 'no-cache', variables: { id: id } });
  };

  const EliminarCliente = (id) => {
    let result = deleteCliente({ fetchPolicy: 'no-cache', variables: { id: id } });
  };

  const handleChangeActivo = (id, checked) => {
    let idTipoPreset = parseInt(id);
    if (isValid(id)) {
      let result = activarPresetUsuario({ fetchPolicy: 'no-cache', variables: { idTipoPreset: idTipoPreset, activo: !checked } });
    }
  };

  const isValid = (id) => {

    switch (id) {
      case 1:
        if (valorFranjaEtaria == '') {
          toast.error('Primero debe seleccionar una Franja etaria');
          return false;
        };
        break;
      case 2:
        if (statePresetTipoModulo.data.length == 0) {
          toast.error('Primero debe agregar un Tipo de Modulo');
          return false;
        };
        break;
      case 3:
        if (statePresetCliente.data.length == 0) {
          toast.error('Primero debe agregar un Cliente');
          return false;
        };
        break;
    }

    return true;
  };

  const handleChangeActivoGeneral = () => {
    let result = activarPresetGeneral({ fetchPolicy: 'no-cache', variables: { activo: !checkedActivoGeneral } });
  };

  const handleSearchCliente = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtBuscarCliente.current.value != "") {
      if (txtBuscarCliente.current.value.length >= 3) {
        setStateClientes(dataOriginalClientes.filter((dataOriginalClientes) => {
          const codClienteBuscar = dataOriginalClientes.cod_Cliente.toLowerCase();
          const nombreBuscar = dataOriginalClientes.nom_Com.toLowerCase();
          const cuitBuscar = dataOriginalClientes.cUIT.toLowerCase();

          const inputBuscar = txtBuscarCliente.current.value.toLowerCase();
          return (
            codClienteBuscar.includes(inputBuscar) ||
            nombreBuscar.includes(inputBuscar) ||
            cuitBuscar.includes(inputBuscar));

        }
        ));
      }
    } else {
      getClientes();
    }
  };

  const handleCleanCliente = () => {
    txtBuscarCliente.current.value = "";
    handleSearchCliente();
    txtBuscarCliente.current.focus();
  };

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)'
      }
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff'
        }
      }
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200
      })
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box'
    }
  }));

  const initialModuleColumns = [
    { field: 'descripcion', headerName: 'Tipo Modulo', flex: 0.1 },
    { field: 'abreviacion', headerName: 'Abreviacion', flex: 0.1 },
    {
      headerName: 'Acciones', flex: 0.1,
      renderCell: (params) => {
        return (
          <div className='actions-cell'>
            <DeleteIcon
              sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt' }}
              titleAccess='Eliminar'
              onClick={() => handleDeleteTipoModulo(params.row)} />

          </div>);

      }
    }];


  const initialClientColumns = [
    { field: 'cod_Cliente', headerName: 'Codigo', flex: 0.1 },
    { field: 'nom_Com', headerName: 'Nombre', flex: 0.1 },
    { field: 'cUIT', headerName: 'CUIT', flex: 0.1 },
    { field: 'delegacion', headerName: 'Delegacion', flex: 0.1 },
    {
      field: 'acciones',
      headerName: 'Acciones', flex: 0.1,
      renderCell: (params) => {
        return (
          <div className='actions-cell'>
            <DeleteIcon
              sx={{ color: '#717171', cursor: 'pointer', fontSize: '14pt' }}
              titleAccess='Eliminar'
              onClick={() => handleDeleteCliente(params.row)} />

          </div>);

      }
    }];


  const initialItemsColumns = [
    { field: 'cod_Cliente', headerName: 'Codigo' },
    { field: 'nom_Com', headerName: 'Nombre' },
    { field: 'cUIT', headerName: 'CUIT' },
    { field: 'delegacion', headerName: 'Delegacion' },
    {
      field: 'seleccionar',
      headerName: 'Seleccionar', flex: 0.1,
      renderCell: (params) => {
        const row = params.row;
        return <Checkbox
          checked={selectedRows.includes(row.cod_Cliente)}
          onClick={() => HandleCheckItems(row)} />;

      }
    }];


  const moduleColumns = useMemo(() => generateColumnsDefaultConfiguration(initialModuleColumns), []);
  const clientColumns = useMemo(() => generateColumnsDefaultConfiguration(initialClientColumns), []);
  const itemsColumns = useMemo(() => generateColumnsDefaultConfiguration(initialItemsColumns), [selectedRows]);

  const HandleCheckItems = (row) => {
    setSelectedRows((current) => {
      if (current.includes(row.cod_Cliente))
        return current.filter((cliente) => cliente !== row.cod_Cliente); else

        return [...current, row.cod_Cliente];
    });
  };

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  return (
    <>
      <div style={{ paddingTop: "30px" }}>
        <FormGroup>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography>Inactivo</Typography>
            <AntSwitch
              checked={checkedActivoGeneral}
              onChange={handleChangeActivoGeneral}
              inputProps={{ 'aria-label': 'ant design' }} />

            <Typography>Activo</Typography>
          </Stack>
        </FormGroup>
        {
          data.tipoPreset.valorEsperado.map((item) => item.descripcion).
            filter((value, index, self) => self.indexOf(value) === index).map((item, index) => {
              let idTipoPreset = index + 1;


              return <>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header">

                    <Typography style={{ fontWeight: 'bold', color: 'black', width: '100%', fontStyle: 'italic' }}>
                      <span>{item}
                      </span>
                    </Typography>
                    <FormGroup>
                      {
                        idTipoPreset == 1 &&
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography>Inactivo</Typography>
                          <AntSwitch
                            id={index}
                            checked={checkedActivoFE}
                            onChange={() => handleChangeActivo(idTipoPreset, checkedActivoFE)}
                            inputProps={{ 'aria-label': 'ant design' }} />

                          <Typography>Activo</Typography>
                        </Stack>
                      }
                      {
                        idTipoPreset == 2 &&
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography>Inactivo</Typography>
                          <AntSwitch
                            id={index}
                            checked={checkedActivoTM}
                            onChange={() => handleChangeActivo(idTipoPreset, checkedActivoTM)}
                            inputProps={{ 'aria-label': 'ant design' }} />

                          <Typography>Activo</Typography>
                        </Stack>
                      }
                      {
                        idTipoPreset == 3 &&
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography>Inactivo</Typography>
                          <AntSwitch
                            id={index}
                            checked={checkedActivoC}
                            onChange={() => handleChangeActivo(idTipoPreset, checkedActivoC)}
                            inputProps={{ 'aria-label': 'ant design' }} />

                          <Typography>Activo</Typography>
                        </Stack>
                      }
                    </FormGroup>
                  </AccordionSummary>
                  {
                    idTipoPreset == 1 &&
                    <AccordionDetails>
                      <FormControl sx={{ backgroundColor: 'white' }}>
                        <FormLabel id="radio-buttons-group-label"></FormLabel>
                        <RadioGroup
                          row
                          aria-labelledby="radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          value={valorFranjaEtaria}
                          onChange={handleFranjaEtaria}>

                          <FormControlLabel value="1" control={<Radio />} label="Pediatrico" />
                          <FormControlLabel value="2" control={<Radio />} label="Adulto" />
                        </RadioGroup>
                      </FormControl>
                    </AccordionDetails>
                  }
                  {
                    idTipoPreset == 2 &&
                    <AccordionDetails>
                      <div style={{ display: 'flex', width: '100%' }}>
                        <FormControl sx={{ backgroundColor: 'white', width: 300 }} size="small">

                          <InputLabel id="select-tipoModulo">TipoModulo</InputLabel>
                          <Select
                            labelId="select-tipoModulo"
                            id="TipoModulo"
                            value={formValues.IdTipoModulo}
                            label="Tipo Modulo"
                            inputRef={IdTipoModulo}
                            onChange={(e) => setFormValues(
                              {
                                ...formValues,
                                IdTipoModulo: e.target.value
                              })
                            }>

                            {dataTipoModulo && dataTipoModulo.map((tipo) => {
                              return <MenuItem value={tipo.idTipoModulo}> {tipo.descripcion} </MenuItem>;
                            })}
                          </Select>
                        </FormControl>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <CustomButton
                          endIcon={<AddIcon />}
                          loadingPosition="end"
                          onClick={handleAddTipoModulo}
                          size="small"
                          variant="contained">

                          Agregar
                        </CustomButton>
                      </div>
                      {
                        statePresetTipoModulo.showDataGrid &&
                        <DataGridGenerico
                          columns={moduleColumns}
                          rows={statePresetTipoModulo.data}
                          toolbar={false} />

                      }
                    </AccordionDetails>
                  }
                  {
                    idTipoPreset == 3 &&
                    <AccordionDetails>
                      <CustomButton
                        endIcon={<AddIcon />}
                        loadingPosition="end"
                        onClick={handleAddCliente}
                        size="small"
                        variant="contained">

                        Agregar
                      </CustomButton>
                      {
                        statePresetCliente.showDataGrid &&
                        <DataGridGenerico
                          columns={clientColumns}
                          rows={statePresetCliente.data}
                          toolbar={false} />

                      }
                    </AccordionDetails>
                  }
                </Accordion>

              </>;
            })
        }
      </div>
      <br /><br /><br />


      <ErrorDialog
        id="dlg-error-chgpass"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />


      <CustomDialog
        maxWidth="lg"
        fullWidth={true}
        open={openDlgCliente}
        title={'Búsqueda de Clientes'}
        onCancel={handleCloseDlgCliente}
        onAccept={handleAddDlgCliente}
        cancelText='Cerrar'
        acceptText='Agregar'>

        <div style={{ display: 'flex', width: '100%' }}>
          <div style={{ fontSize: '13pt' }}>
            <FormControl sx={{ backgroundColor: 'white' }} size="small">
              <div style={{ display: 'flex', width: '100%' }}>
                <TextField
                  className="input-300"
                  label="Filtrar clientes"
                  name="txtBuscarCliente"
                  size="small"
                  type="text"
                  variant="outlined"
                  inputRef={txtBuscarCliente}
                  onKeyUp={handleSearchCliente}
                  InputProps={{
                    endAdornment:
                      <InputAdornment position="end">
                        <SearchIcon
                          onClick={handleSearchCliente}
                          sx={{ cursor: 'pointer' }} />

                        <ClearIcon
                          onClick={handleCleanCliente}
                          sx={{ cursor: 'pointer' }} />

                      </InputAdornment>

                  }} />

              </div>
            </FormControl>
          </div>
        </div>

        <br />

        <DataGridGenerico
          columns={itemsColumns}
          rows={stateClientes}
          toolbar={false}
        />

      </CustomDialog>
    </>);



};